export var ImageFillMode;
(function (ImageFillMode) {
    ImageFillMode["Cover"] = "cover";
    ImageFillMode["Contain"] = "contain";
    ImageFillMode["Fit"] = "fit";
})(ImageFillMode || (ImageFillMode = {}));
export const ImagePluginID = 'image';
